<template>
  <ResumeSection v-if="activeResponses"
                 toggle
                 :isOpen="isOpenOnMobile"
                 style="z-index: 2;"
                 :title="$tResumePage('Active responses')"
                 :count="activeResponses.count">
    <template v-slot:icon>
      <BaseSvg name="ico-gear-stroke" width="2.5rem" height="2.5rem"/>
    </template>
    <template v-slot:default>
      <div class="resume-active-responses">
        <ResumeActiveResponsesItem v-for="(item, index) in activeResponses.responses_list"
                                   :key="$get(item, 'vacancy.ID') + '_' + index"
                                   :response="item"/>
      </div>
    </template>
  </ResumeSection>
</template>

<script>
  import ResumeSection from './ResumeSection'
  import ResumeActiveResponsesItem from './ResumeActiveResponsesItem'

  export default {
    name: "ResumeActiveResponses",
    components: {
      ResumeSection,
      ResumeActiveResponsesItem
    },
    props: {
      activeResponses: Object,
      isOpenOnMobile: Boolean,
    }
  };
</script>
